const Chart = require("../../Dashboard/Chart/chart");

const ChartDataLabels = require("chartjs-plugin-datalabels");

const { formatCentsToCurrency } = require("app/util/formatter/currency");

const ValueChart = React.createClass({
  render: function () {
    return <div>
      <div className="h-280 ovy-auto thinScrollbar">
        <Chart
          type="pie"
          plugins={[ChartDataLabels]}
          datasets={[
            {
              data: this.props.data.map(item => item.value)
            }
          ]}
          labels={this.props.data.map(item => (
            item.name || "Indefinido"
          ))}
          options={{
            legend: { position: "left" },
            plugins: {
              datalabels: false
            },
            onHover: this.props.onHover,
            onClick: this.props.onClick,
            tooltips: {
              callbacks: {
                title: ([tooltipItem]) => {
                  return this.props.data[tooltipItem.index].name || "Indefinido"
                },
                label: (tooltipItem) => {
                  return `Valor: ${
                    formatCentsToCurrency(
                      this.props.data[tooltipItem.index].value
                      )
                    } (${this.props.getPercentageValue(
                        tooltipItem,
                        this.props.data,
                        this.props.total
                      )}%)`;
                },
                afterLabel: (tooltipItem) => {
                  return this.props.data[tooltipItem.index].count + " negócios";
                },
              },
            }
          }}
        />
      </div>
    </div>
  }
})

module.exports = ValueChart;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Widgets/ProductsBestSellers/value-chart.jsx